import { useState, FC } from 'react';
import { Formik, Field } from 'formik';
import Portal from '../../Portal';
import cx from 'classnames';
import styles from './AddNew.module.scss';
import Button from '../../GroupActions/Button';
import TextField from '../../Inputs/TextField';
import SelectField from '../../Inputs/SelectField';
import ToggleField from '../../Inputs/ToggleField';
// import RadioField from '../../Inputs/RadioField;

export interface AddNewFormProps {
  onClick: (k: string, v: any) => void;
  type: string;
  options: any;
}
const AddNewForm: FC<AddNewFormProps> = ({ onClick, type, options }) => {
  const [isOpen, setIsOpen] = useState(false);
  // const opts = Object.entries(options).map((item: any) => ({ value: item[1], label: item[0] }));
  return (
    <div>
      <Button theme='primary' variant='rounded' onClick={() => setIsOpen(true)}>
        Add New Token
      </Button>
      {isOpen && (
        <Portal selector='#modal'>
          <div className={styles.modal}>
            <div className={styles.modal__shade} onClick={() => setIsOpen(false)} />
            <div className={styles.modal__form}>
              <Formik
                initialValues={{
                  token_name: '',
                  token_value: '',
                  token_type: type,
                  isReference: false,
                }}
                onSubmit={(values) => {
                  console.log(values);
                  onClick(
                    values.token_name,
                    // @ts-ignore
                    typeof values.token_value === 'object' ? values.token_value.value : values.token_value
                  );
                  setIsOpen(false);
                }}
              >
                {({ values, handleSubmit }) => (
                  <>
                    {isOpen && (
                      <>
                        <TextField name='token_name' label='Token Name' />
                        <ToggleField name='isReference' label='Link to another token?' disabled={false} />

                        {!values.isReference ? (
                          <TextField name='token_value' label='Value' />
                        ) : (
                          <SelectField name='token_value' label='Value' options={options} />
                        )}
                        <Button theme='primary' variant='rounded' onClick={handleSubmit} label='Submit' />
                      </>
                    )}
                  </>
                )}
              </Formik>
            </div>
          </div>
        </Portal>
      )}
    </div>
  );
};

export default AddNewForm;
